<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/80UATF/tc-custom/9789948748151.jpg?1725723408821" alt="This image is the cover for the book عَصَافِيرُ لَا تُجِيدُ التَّحْلِيقَ"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">عَصَافِيرُ لَا تُجِيدُ التَّحْلِيقَ
      </h1>
      <p class="bookDescription body article font2">
        <p>عندما خلق الله هذا الكون بما به مِن مخلوقات لَم يخلقه عبثًا؛ فكلٌّ له مهامه ودوره كي تستمرَّ الحياة بنظام متوازن. في عالم الحيوان والطير والحشرات وغيرها، هناك العديد مِن الصفات المشتركة التي توجد أيضًا في عالم البشر، منها صفات حميدة ومنها صفات ذميمة. وفي هذا الكتاب هناك مجموعة قصصية تدور أحداثها ما بين الخير والشر، يُمثِّلها ذلك الصراع القائم منذ بدْء الخليقة بين الكائنات الحية، تتنوَّع شخصياتها وتتوزَّع أدوارها ما بين الحيوان والطير، ولا تخلو منها مِرآة الواقع على يد الإنسان، مِن أجل أن ترسو سفينة النجاة ولا يطغى جانب الشر ويسود الظلم.  لا بدَّ أنَّ هناك طريقًا وومضة – ولو أتت خافتة – تحمل في طياتها نور العدل والحقِّ وكبح جماح الصراع، في بيئة تسودها الألفة والودُّ. وكم ستُزهر جنبات خليفة الله، ذلك الإنسان الذي ميَّزه الله بالعقل، لو يتحلَّى بتلك الصفات الحسنة وينبذ صفات الحيوان الذميمة التي لا تكون إلا في عالم الغاب. *وقتًا ممتعًا أتمنَّاه لكلِّ قارئ لهذا الكتاب في هذه السلسلة القصصيَّة المتنوِّعة.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        خديجة عبد الله الشيخي
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6dc20fc6